import React from 'react'

import Card from 'pages/HehmDevice/HehmDashboard/Card'

type Props = {
  onNavigate: (tab: string) => void
}

const RuntimeHistoryCard = ({ onNavigate }: Props) => (
  <Card
    title="Runtime History"
    icon="/img/rtgraph.png"
    iconStyle={{ height: '21px' }}
    onClick={() => onNavigate('runtime-history')}
  >
    <Card.ItemValue>Click to view historical runtime information</Card.ItemValue>
  </Card>
)

export default RuntimeHistoryCard
